"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _bookingStatus = _interopRequireDefault(require("./bookingStatus"));
var _consignerInfo = _interopRequireDefault(require("./consignerInfo"));
var _consignerReceiveInfo2 = _interopRequireDefault(require("./consignerReceiveInfo"));
var _consignerInfoOne2 = _interopRequireDefault(require("./consignerInfoOne"));
var _consignerInfoTwo = _interopRequireDefault(require("./consignerInfoTwo"));
var _bookCargo = _interopRequireDefault(require("./bookCargo"));
var _utils = require("@/utils");
var _dropTitle = _interopRequireDefault(require("./dropTitle"));
var _bookInfo = _interopRequireDefault(require("./bookInfo"));
var _boxInfo = _interopRequireDefault(require("./boxInfo"));
var _bookingMain = _interopRequireDefault(require("./bookingMain"));
var _acceesorySitc = _interopRequireDefault(require("@/componentsBuz/Accessory/acceesorySitc.vue"));
var _copyBook = _interopRequireDefault(require("./copyBook"));
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
var _MessageInputText = _interopRequireDefault(require("./MessageInputText.vue"));
var _validate = require("@/utils/validate");
var _validCustomerInfoDialog = _interopRequireDefault(require("./validCustomerInfoDialog"));
var _validateContainerNoDialog = _interopRequireDefault(require("./validateContainerNoDialog"));
var _chargeInfo = _interopRequireDefault(require("@/views/booking/bookingSpace/components/chargeInfo.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//  下货箱信息
var _default = exports.default = {
  name: "bookMaterialsDetail",
  components: {
    chargeInfo: _chargeInfo.default,
    sailSchedule: _SailSchedule.default,
    acceesorySitc: _acceesorySitc.default,
    copyBook: _copyBook.default,
    bookingMain: _bookingMain.default,
    consignerInfo: _consignerInfo.default,
    consignerReceiveInfo: _consignerReceiveInfo2.default,
    consignerInfoOne: _consignerInfoOne2.default,
    consignerInfoTwo: _consignerInfoTwo.default,
    dropTitle: _dropTitle.default,
    bookInfo: _bookInfo.default,
    bookCargo: _bookCargo.default,
    boxInfo: _boxInfo.default,
    bookingStatus: _bookingStatus.default,
    MessageInputText: _MessageInputText.default,
    validCustomerInfoDialog: _validCustomerInfoDialog.default,
    validateContainerNoDialog: _validateContainerNoDialog.default
  },
  data: function data() {
    var _this = this;
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!(0, _validate.validateNull)(value)) {
        if (value.length > 500) {
          callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules1')));
        }
        var array = value.split(";");
        for (var i = 0; i < array.length; i++) {
          if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(array[i])) {
            callback(new Error(_this.$t('userCenter.userInfo.emailCheckRules2')));
          }
        }
        callback();
      } else {
        callback();
      }
    };
    var validateContainerNo = function validateContainerNo(rule, value, callback) {
      if (value !== '') {
        if (value.toString().length === 11) {
          callback();
        } else {
          callback(new Error(_this.$t('validate.containerNoIsFixed')));
        }
      } else {
        callback();
      }
    };
    return {
      currentDialogIndex: '',
      dialogContent: '',
      loadingTrue: false,
      showCargoInfo: false,
      loading: null,
      formOne: {},
      copyId: '',
      isDisable: false,
      dialogVisible: false,
      disabledType: false,
      copyVisible: false,
      sailScheduleDialogVisible: false,
      vessNameVoy: '',
      bookingId: '',
      preLockFlag: null,
      allValidCustomerInfo: [],
      validCustomerTips: [],
      validCustomerInfoVisible: false,
      validCustomerInfoFlag: true,
      validateContainerNoMsg: '',
      saveIndex: null,
      validateContainerNoVisible: false,
      validateContainerNoFlag: true,
      topBlInfo: null,
      form: {
        clickButton: false,
        priceRemark: '',
        remark: '',
        // 是否订舱推广
        singleContainerFlag: 0,
        webBkSocComs: [],
        webBkImoComs: [],
        webBkYardComs: [],
        webFeeItemComs: [],
        webBkDocumentComs: [],
        webBkRoutingComs: [],
        webBkReeferComs: [],
        webBkAkComs: [],
        webBkHgComs: [],
        pol: '',
        webBkPreContainerComs: [{
          containerType: '',
          quantity: null,
          cargoTypeCode: '',
          pickupDate: '',
          returnDate: '',
          pickUpDepot: '',
          returnDepot: ''
        }],
        //下货箱信息

        //  vesselCode:'',
        //  vesselName:'',
        //  vesselNameCn:'',
        //  saillingDate:'',
        //  eta:'',
        //  bookingFwdPerson:'',
        //  bookingFwdTel:'',
        //  bookingFwdEmail:'',
        //  actualShipper:'',
        //  bkNo:'',
        //  blNo:'',
        //  bookingType:'',
        //  transportationTerms:'',
        //  paidPalce:'',
        //  paidType:'',
        //  etd:'',
        // documentType:'',
        //  deliveryDocumentMethod:0,
        //  wbillNo:'',
        //  agreementNo:'',
        //  freeTimeNo:'NIL',
        //  expCustomsCargoType:'',
        //  sales:'',
        //  por:'',
        //  pol:'',
        //  pod:'',
        //  del:'',
        //  porName:'',
        //  polName:'',
        //  podName:'',
        //  delName:'',
        //  vipFlag: 0,
        //  masterBLFlag: 0,
        cargoDesc: '',
        cargoGrossWeight: null,
        tsFlag: 0,
        dgCheckFlag: 0,
        rfCheckFlag: 0,
        akCheckFlag: 0,
        socCheckFlag: 0,
        hgCheckFlag: 0,
        // packageType:'PKGS', //包装类型
        // packageDesc:'PACKAG(S)',//包装描述
        // cargoQuantity:0,//货物数量
        cargoPackageType: 'PKGS',
        //包装类型
        cargoPackageDesc: 'PACKAG(S)',
        //包装描述
        cargoQuantity: 0,
        //货物数量
        cargoSize: 0,
        //货物重量
        cargoShippingMark: 'N/M' //唛头
      },
      packageDescList: [],
      packageTypeList: [],
      cargoListType: [{
        code: '0',
        name: 'Export'
      }, {
        code: '1',
        name: 'Reshipment'
      }],
      contactTypeCodeList: [],
      containerStatusList: [],
      rateBaseList: [{
        value: '0',
        labelZh: '摄氏度',
        labelEh: '摄氏度'
      }, {
        value: '1',
        labelZh: '华氏度',
        labelEh: '华氏度'
      }],
      transportationTermsList: [{
        value: '1',
        labelZh: 'SIMIS主系统基础数据-运输条款',
        labelEh: 'SIMIS main system basic data - Shipping terms'
      }],
      bookingTypeList: [],
      paidTypeList: [{
        value: '0',
        labelEh: 'PP'
      }, {
        value: '1',
        labelEh: 'CC'
      }],
      documentTypeList: [{
        value: '0',
        labelZh: '提单',
        labelEh: 'BILL OF LADING'
      }, {
        value: '1',
        labelZh: '海运提单',
        labelEh: 'SEA WAYBILL'
      }],
      cargoList: [],
      containerTypeList: [{
        value: '0',
        labelEh: '20GP'
      }, {
        value: '1',
        labelEh: '40GP'
      }],
      cargoTypeCodeList: [{
        value: '0',
        labelZh: '普通',
        labelEh: 'DRY'
      }, {
        value: '1',
        labelZh: '冻货',
        labelEh: 'REEFER'
      }, {
        value: '2',
        labelZh: '半危',
        labelEh: 'SEMI-HAZ'
      }, {
        value: '3',
        labelZh: '全危',
        labelEh: 'HAZARDOUS'
      }, {
        value: '4',
        labelZh: '单挂衣',
        labelEh: 'HG-1(ONE BAR)'
      }, {
        value: '5',
        labelZh: '双挂衣',
        labelEh: 'HG-1(TWO BARS)'
      }, {
        value: '6',
        labelZh: 'OT-1超高1M内',
        labelEh: 'OT-1(OH WITHIN 1M)'
      }, {
        value: '7',
        labelZh: 'OT-2超高1M外2M内',
        labelEh: 'OT-1(OH 1M TO 2M)'
      }, {
        value: '8',
        labelZh: 'FR-1超宽或超高1M内',
        labelEh: 'FR-1(OH OR OW WITHIN 1M)'
      }, {
        value: '9',
        labelZh: 'FR-2超宽或超高1M内',
        labelEh: 'FR-1(OH AND OW WITHIN 1M)'
      }, {
        value: '10',
        labelZh: 'FR-3超限1M以上',
        labelEh: 'FR-(3OH OR OW MORE THAN 1M)'
      }, {
        value: '11',
        labelZh: '空箱',
        labelEh: 'EMPTY'
      }, {
        value: '12',
        labelZh: '半开门',
        labelEh: 'DOOR OPEN'
      }, {
        value: '13',
        labelZh: '废品',
        labelEh: 'SCRAPS'
      }, {
        value: '14',
        labelZh: 'FR(OW)超高',
        labelEh: 'FR(OW)'
      }, {
        value: '15',
        labelZh: 'FR(FV)超高和超宽',
        labelEh: 'FR(RV)'
      }, {
        value: '16',
        labelZh: 'OT(OH)超高',
        labelEh: 'OT(OH)'
      }, {
        value: '17',
        labelZh: 'FR(OH)超高',
        labelEh: 'FR(OH)'
      }, {
        value: '18',
        labelZh: '废纸',
        labelEh: 'WASTE PARER'
      }, {
        value: '19',
        labelZh: '空箱半危',
        labelEh: 'ENPTY%DG'
      }, {
        value: '20',
        labelZh: 'FR-4[FR超长]',
        labelEh: 'FR-4(OL)'
      }, {
        value: '21',
        labelZh: 'FR-5[FR超长和超宽]',
        labelEh: 'FR-5(OL AND OW)'
      }, {
        value: '22',
        labelZh: 'FR-6[FR超长和超宽超高]',
        labelEh: 'RF-6(OL AND OW AND OH)'
      }, {
        value: '23',
        labelZh: 'FR-7[FR超长和超高]',
        labelEh: 'FR-7(OL AND OH)'
      }],
      pickupYardList: [{
        value: '0',
        labelEh: 'Yard1'
      }, {
        value: '1',
        labelEh: 'Yard2'
      }],
      isSplitList: [{
        value: '0',
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: '1',
        labelEh: 'YES',
        labelZh: '是'
      }],
      lineTypeList: [{
        value: '0',
        labelEh: 'Feeder',
        labelZh: '支线'
      }, {
        value: '1',
        labelEh: 'Ocean',
        labelZh: '干线'
      }],
      directionList: [{
        value: '0',
        labelEh: 'One Way',
        labelZh: '单程'
      }, {
        value: '1',
        labelEh: 'Two Way',
        labelZh: '双程'
      }],
      fullEmptyTypeList: [{
        value: '0',
        labelEh: 'Full',
        labelZh: '重去重回'
      }, {
        value: '1',
        labelEh: 'Empty',
        labelZh: '重去重回'
      }, {
        value: '2',
        labelEh: 'Empty',
        labelZh: '空去回重'
      }, {
        value: '3',
        labelEh: 'Empty',
        labelZh: '空去回空'
      }],
      containerSizeList: [{
        value: '0',
        labelEh: 'Standard container size',
        labelZh: '标准集装箱尺寸'
      }, {
        value: '1',
        labelEh: 'Non-standard container size',
        labelZh: '非标准集装箱尺寸'
      }],
      fullEmptyTypeListType: [{
        value: 1,
        labelEh: 'Horizontal bar',
        labelZh: '单杠'
      }, {
        value: 2,
        labelEh: 'Parallel bars',
        labelZh: '双杠'
      }],
      navTabList: [{
        name: '基础信息',
        nameEn: 'Basic'
      }, {
        name: '收发通信息',
        nameEn: 'Shipper/Consignee '
      }, {
        name: '货物信息',
        nameEn: 'Cargo '
      }, {
        name: '下货纸箱信息',
        nameEn: 'Precontainer'
      }, {
        name: '其他信息',
        nameEn: 'Other  '
      }],
      selectedIndex: 0,
      rules: {
        componentDesc: [{
          required: true,
          trigger: 'blur'
        }],
        containerType: [{
          required: true,
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          trigger: 'blur'
        }],
        cargoTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        containerStatus: [{
          required: true,
          trigger: 'change'
        }],
        tripNumber: [{
          required: true,
          trigger: 'blur'
        }],
        lineType: [{
          required: true,
          trigger: 'change'
        }],
        serviceLineCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselCode: [{
          required: true,
          trigger: 'change'
        }],
        vesselName: [{
          required: true,
          trigger: 'blur'
        }],
        voyageNo: [{
          required: true,
          trigger: 'blur'
        }],
        voyageLeg: [{
          required: true,
          trigger: 'blur'
        }],
        portFrom: [{
          required: true,
          trigger: 'change'
        }],
        portTo: [{
          required: true,
          trigger: 'change'
        }],
        classType: [{
          required: true,
          trigger: 'blur'
        }],
        unSeriseNo: [{
          required: true,
          trigger: 'blur'
        }],
        property: [{
          required: true,
          trigger: 'blur'
        }],
        packageType: [{
          required: true,
          trigger: 'change'
        }],
        emergencySeq: [{
          required: true,
          trigger: 'blur'
        }],
        emergencyTelNo: [{
          required: true,
          trigger: 'blur'
        }],
        // imoQuantity: [ { required: true, trigger: 'blur' }],
        grossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        netWeight: [{
          required: true,
          trigger: 'blur'
        }],
        packagingCode: [{
          required: true,
          trigger: 'blur'
        }],
        hsCodeCn: [{
          required: true,
          message: this.$t('home.hsCodeCnNotNull'),
          max: 8,
          trigger: 'blur'
        }],
        hsCodeJp: [{
          required: false,
          max: 6,
          trigger: 'blur'
        }, {
          validator: this.validateHsCodeJp,
          trigger: 'blur'
        }],
        hsCode: [{
          required: false,
          max: 20,
          trigger: 'blur'
        }, {
          validator: this.validateHsCode,
          trigger: 'blur'
        }],
        casNo1: [{
          required: true,
          trigger: 'blur'
        }],
        casNo2: [{
          required: true,
          trigger: 'blur'
        }],
        casNo3: [{
          required: true,
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          trigger: 'blur'
        }],
        contactNumber: [{
          required: true,
          trigger: 'blur'
        }],
        contactTypeCode: [{
          required: true,
          trigger: 'change'
        }],
        //  unit: [ { required: true, trigger: 'blur' }],
        temperature: [{
          required: true,
          trigger: 'blur'
        }],
        akLength: [{
          required: true,
          trigger: 'blur'
        }],
        akWidth: [{
          required: true,
          trigger: 'blur'
        }],
        akHigth: [{
          required: true,
          trigger: 'blur'
        }],
        akGrossWeight: [{
          required: true,
          trigger: 'blur'
        }],
        akNetWeight: [{
          required: true,
          trigger: 'blur'
        }],
        // quantity: [ { required: true, trigger: 'blur' }],
        commodityName: [{
          required: true,
          trigger: 'blur'
        }],
        overFront: [{
          required: true,
          trigger: 'blur'
        }],
        overAfter: [{
          required: true,
          trigger: 'blur'
        }],
        overPortside: [{
          required: true,
          trigger: 'blur'
        }],
        overStarboard: [{
          required: true,
          trigger: 'blur'
        }],
        intakeNum: [{
          required: true,
          trigger: 'blur'
        }],
        overHeight: [{
          required: true,
          trigger: 'blur'
        }],
        direction: [{
          required: true,
          trigger: 'change'
        }],
        containerSize: [{
          required: true,
          trigger: 'change'
        }],
        sealNo1: [{
          required: true,
          trigger: 'blur'
        }],
        //  overWeight: [ { required: true, trigger: 'blur' }],
        weight: [{
          required: true,
          trigger: 'blur'
        }],
        //  commodityCode: [ { required: true, trigger: 'blur' }],
        documentNo: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        packageCode: [{
          required: true,
          trigger: 'blur'
        }],
        rateBase: [{
          required: true,
          trigger: 'change'
        }],
        cargoDesc: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        shippingMark: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        packageDesc: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        cargoGrossWeight: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }, {
          validator: this.validateCargoGrossWeight,
          trigger: 'blur'
        }],
        paidType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        deliveryDocumentMethod: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        transportationTerms: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        freeTimeNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        containerNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }, {
          required: true,
          validator: validateContainerNo,
          trigger: ['change', 'blur']
        }],
        containerManager: [{
          required: true,
          trigger: 'change'
        }],
        por: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        pol: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        pod: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        del: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        porName: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        polName: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        podName: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        delName: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        bkNo: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        //  expCustomsCargoType:[{required: true,  message: this.$t('home.placehold'),trigger: 'change' }],
        expCustomsCntrType: [{
          required: false
        }],
        cargoShippingMark: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        cargoQuantity: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        // cargoGrossWeight:[{required: true,  message: this.$t('home.placehold'),trigger: 'blur' }],
        cargoSize: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }],
        cargoPackageType: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        cargoPackageDesc: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }],
        bookingFwdEmail: [{
          required: false,
          validator: validateEmail,
          trigger: 'blur'
        }],
        catalogContent: [{
          required: false,
          message: this.$t('home.messageSix'),
          trigger: 'blur'
        }, {
          required: false,
          type: 'email',
          message: this.$t('home.messageThree'),
          trigger: ['blur', 'change']
        }]
        // socReturn: [ { required: true,  message: this.$t('home.placehold'),trigger: 'change' }]
      }
    };
  },
  watch: {
    isToastSave: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          if (this.handleBeforeRouteLeave()) {
            this.handleCloseDetail();
          } else {
            this.ishandleDelTag();
          }
        }
      },
      immediate: true
    },
    'form.pol': function formPol(newVal) {
      var _this2 = this;
      console.log(newVal, '111');
      if (newVal === 'CNSHK' || newVal === 'CNNSA') {
        this.rules.paidPalce = [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }];
        this.$set(this.rules, 'paidType', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
      } else {
        this.rules.paidPalce = [];
        this.$nextTick(function () {
          var _this2$$refs$form;
          (_this2$$refs$form = _this2.$refs.form) === null || _this2$$refs$form === void 0 ? void 0 : _this2$$refs$form.clearValidate(['paidPalce']); // 确保 DOM 更新后执行
        });
      }
      if (newVal.startsWith('KR')) {
        this.rules.documentNo = [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }];
        this.$set(this.rules, 'documentNo', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        this.$set(this.rules, 'remark', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        this.$set(this.rules, 'docCommodity', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        // this.$set(this.rules, 'hsCode', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        // this.$set(this.rules, 'hsCodeCn', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        // this.$set(this.rules, 'hsCodeJp', [{ required: true,  message: this.$t('home.placehold'),trigger: 'blur' }]);
        this.$set(this.rules, 'expCustomsCargoType', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'blur'
        }]);
        this.$set(this.rules, 'expCustomsCntrType', [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }]);
      } else {
        // this.rules.documentNo = [];
        this.rules.remark = [];
        this.rules.docCommodity = [];
        // this.rules.hsCode = [];
        // this.rules.hsCodeCn = [];
        // this.rules.hsCodeJp = [];
        this.rules.expCustomsCargoType = [];
      }
      // if(newVal === 'CNTAO'){
      //    this.form.webBkYardComs = [{pickupYard:'',returnYard:null,pickUpDate:''}]
      //    this.rules.pickupYard = [{ required: true, trigger: 'blur' }];
      //    this.rules.returnYard = [{ required: true,  trigger: 'blur' }];
      //    this.rules.pickupDate = [{ required: true, trigger: 'blur' }];
      // }else{
      // this.form.webBkYardComs = []
      // this.rules.pickUpDepot = [];
      // this.rules.returnDepot = [];
      // this.rules.pickupDate = [];
      // }
    },
    'form.deliveryDocumentMethod': {
      handler: function handler(newVal) {
        if (newVal === 2) {
          this.$set(this.rules, 'wbillNo', [{
            required: true,
            message: this.$t('home.placehold'),
            trigger: 'blur'
          }]);
        } else {
          this.form.wbillNo = '';
          this.rules.wbillNo = [];
          this.$refs.form.clearValidate(['wbillNo']);
        }
      },
      immediate: true // 立即执行一次监听器
    },
    'form.agreementNo': {
      handler: function handler(newVal) {
        var _this3 = this;
        if (newVal !== '' && newVal !== null) {
          var data = {
            por: this.form.por,
            del: this.form.del,
            agreementNo: newVal,
            etd: this.form.etd
          };
          (0, _booking.getFreeTimeNo)(data).then(function (res) {
            if (res.data === 'NIL') {
              if ((0, _validate.validateNull)(_this3.form.freeTimeNo)) {
                _this3.form.freeTimeNo = res.data;
              }
            } else {
              _this3.form.freeTimeNo = res.data;
            }
            console.log(newVal, 'ft', _this3.form.freeTimeNo);
          });
        }
      },
      deep: true
    },
    'form.webBkContainerComs': {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.validateContainerNoFlag = true;
        }
      },
      immediate: true,
      deep: true
    }
    //    'form.socCheckFlag': {
    //         handler: function (val) {
    //             console.log(val,'SOC00000000000')
    //             if(val){
    //                 this.$set(this.rules, 'socReturn', [{ required: true, message: this.$t('home.placehold'), trigger: 'change' }]);
    //             }else{
    //                 this.rules.socReturn = []
    //                 this.$refs.form.clearValidate(['socReturn']);
    //             }

    //         },
    //         immediate: true
    //     },
    //    'form.webBkPreContainerComs': {
    //      handler: function(newVal, oldVal) {
    //        console.log(newVal,'newVal')
    //        newVal.forEach((item)=>{
    //          item.containerType * item.quantity

    //        })
    //     //    webBkPreContainerComsTotal
    //      },
    //      deep: true,
    //     },
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo', 'isToastSave', 'isToastSavePath'])), {}, {
    isCanSave: function isCanSave() {
      var status = this.form.status;
      console.log('9989898', status);
      if (status === '1' || status == '14' || status === '13' || status === '5' || status === '8') {
        return true;
      }
      return false;
    },
    isCanSaveDraft: function isCanSaveDraft() {
      var status = this.form.status;
      if (status === '1' || status === '14') {
        return true;
      }
      return false;
    },
    isCanSaveCopy: function isCanSaveCopy() {
      var status = this.form.status;
      if (status === '10' || status == null || status === '11' || status === '0') {
        return false;
      }
      return true;
    },
    total: function total() {
      return this.form.webBkPreContainerComs.filter(function (item) {
        return item.containerType && item.quantity;
      }) // 过滤掉 containerType 和 quantity 为空或无效的项
      .map(function (item) {
        return "".concat(item.containerType, "*").concat(item.quantity);
      }) // 对剩余的项进行拼接
      .join(';'); // 用分号连接所有项
    }
  }),
  mounted: function mounted() {
    var _this4 = this;
    this.$dictionary.get(['BOOKING_WEB_STATUS_COM', 'DOC_SOCRETURN', 'SOC_CONTAINER_SIZE', 'MKT_SOC_FULL_EMPTY', 'DOC_DG_DIVISION_PACKAGING_GROUP', 'BOOKINGTYPE', 'CDM_SERVICE_MODE', 'PAID_TYPE', 'DOC_CONTACT_TYPE', 'CONTAINER_STATUS'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      console.log(res, 'res');
      _this4.bookingTypeList = res.BOOKINGTYPE;
      _this4.vesselTypeList = res.CDM_SERVICE_MODE;
      _this4.paidTypeList = res.PAID_TYPE;
      _this4.packageDescList = res.DOC_DG_DIVISION_PACKAGING_GROUP;
      _this4.containerSizeList = res.SOC_CONTAINER_SIZE;
      _this4.fullEmptyTypeList = res.MKT_SOC_FULL_EMPTY;
      _this4.directionList = res.DOC_SOCRETURN;
      _this4.bookingStatusList = res.BOOKING_WEB_STATUS_COM ? res.BOOKING_WEB_STATUS_COM : [];
      _this4.contactTypeCodeList = res.DOC_CONTACT_TYPE ? res.DOC_CONTACT_TYPE : [];
      _this4.containerStatusList = res.CONTAINER_STATUS ? res.CONTAINER_STATUS : [];
      // soc
    });
    this.getValidCustomerInfoList();
  },
  activated: function activated() {
    this.bookInfo = this.$route.query.bookInfo;
    this.bookingId = this.$route.query.id;
    this.isDisable = this.$route.query.type === 'Look' || false;
    console.log(this.$route.query.bookInfo, '88888', this.bookingId);
    console.log(this.userInfo, 'userInfo');
    this.bookingHeadWebInitProps();
    this.queryListPackageType();

    // this.$refs.acceesorySitc.dialogVisible = true
  },
  beforeDestroy: function beforeDestroy() {
    this.bookInfo = null;
    this.bookingId = null;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.handleBeforeRouteLeave()) {
      this.handleCloseDetail();
    } else {
      next();
    }
  },
  methods: {
    validateNull: _validate.validateNull,
    validateHsCodeJp: function validateHsCodeJp(rule, value, callback) {
      if (this.form.webBkRoutingComs.some(function (item) {
        return item.portTo.startsWith('JP');
      }) && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t("home.hsCodeJpNotNull")));
      } else if (!(0, _validate.validateNull)(value) && !/^\d{6}$/.test(value)) {
        callback(new Error(this.$t("home.hsCodeJpNotNum6")));
      } else {
        callback();
      }
    },
    validateHsCode: function validateHsCode(rule, value, callback) {
      if (this.form.webBkRoutingComs.some(function (item) {
        return item.portFrom.startsWith('KR');
      }) && (0, _validate.validateNull)(value)) {
        callback(new Error(this.$t("home.hsCodeNotNull")));
      } else if (!(0, _validate.validateNull)(value) && !/^\d{6}$/.test(value)) {
        callback(new Error(this.$t("home.hsCodeKrNotNum6")));
      } else {
        callback();
      }
    },
    validateCargoGrossWeight: function validateCargoGrossWeight(rule, value, callback) {
      var _this5 = this;
      if (value === 0) {
        if (this.form.bookingType !== 2 && !this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0014';
        })) {
          this.$confirm(this.$t('home.checkCargoGrossWeight1'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            callback(new Error(_this5.$t('home.checkCargoGrossWeight1')));
          });
        } else {
          callback();
        }
      } else {
        if (this.form.bookingType === 2 || this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0014';
        })) {
          this.$confirm(this.$t('home.checkCargoGrossWeight2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            callback();
          });
        } else {
          callback();
        }
      }
    },
    // 打开提示框
    openDialog: function openDialog(item, index, biteLength) {
      this.dialogContent = item;
      this.currentDialogIndex = index;
      this.$refs.myDialog.openDialog(biteLength);
    },
    // 提交
    confirm: function confirm(inpText) {
      if (this.currentDialogIndex === 3) {
        this.form.remark = inpText;
      } else if (this.currentDialogIndex === 4) {
        this.form.priceRemark = inpText;
      } else if (this.currentDialogIndex === 1) {
        this.form.cargoDesc = inpText;
      } else if (this.currentDialogIndex === 2) {
        this.form.cargoShippingMark = inpText;
      }
    },
    parseTime: _utils.parseTime,
    handleBeforeRouteLeave: function handleBeforeRouteLeave() {
      var data = {
        newData: this.newData || this.form,
        oldData: this.oldData
      };
      if (data.oldData) {
        delete data.oldData.sales;
      }
      if (data.newData) {
        delete data.newData.sales;
      }
      var newFormString = JSON.stringify(data.newData);
      var oldFormString = JSON.stringify(data.oldData);
      if (newFormString && oldFormString && oldFormString !== newFormString) {
        return true;
      } else {
        return false;
      }
    },
    handleCloseLast: function handleCloseLast() {
      if (this.handleBeforeRouteLeave()) {
        this.handleCloseDetail();
      } else {
        this.ishandleDelTag();
      }
    },
    handleCloseDetail: function handleCloseDetail() {
      var _this6 = this;
      this.$confirm(this.$t('home.closeWaring'), this.$t('confirmMsg.title'), {
        cancelButtonText: this.$t('home.closeWaringTwo'),
        confirmButtonText: this.$t('home.buttonAdd'),
        type: 'warning',
        distinguishCancelAndClose: true
      }).then(function () {
        _this6.handleSave(14);
        _this6.clickButton = true;
      }).catch(function (action) {
        if (action === 'close') {} else {
          _this6.ishandleDelTag();
        }
      });
    },
    ishandleDelTag: function ishandleDelTag() {
      var data = {
        view: this.isToastSavePath || this.$route
      };
      this.$store.dispatch('tagsView/detailTabDelete', data);
      this.$store.dispatch("isSaveTip/isToastSave", false);
    },
    delTag: function delTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
      });
    },
    generateAndSortArray: function generateAndSortArray(webBkCusCatalogComs, sequence) {
      var result = [];
      sequence.forEach(function (seq) {
        var found = webBkCusCatalogComs.find(function (item) {
          return item.sequence === seq;
        });
        if (found) {
          result.push(found);
        } else {
          var newObj = {
            catalogContent: '',
            bkCusCatalogWebComId: null,
            bkCustomerWebComId: null,
            sequence: seq,
            printOrder: seq
          }; // Default values assumed based on the example
          result.push(newObj);
        }
      });
      return result;
    },
    // 处理收法通信息
    handleInfoShou: function handleInfoShou(data) {
      // 数组 a
      var a = [0, 1, 2, 3];
      // 遍历数组 a
      a.forEach(function (type) {
        // 查找是否存在对应的 customerType
        var exists = data.some(function (item) {
          return item.customerType === type;
        });
        // 如果不存在，添加新的对象
        if (!exists) {
          data.push({
            companyName: null,
            customerName: null,
            customerCode: null,
            customerType: type,
            webBkCusCatalogComs: []
          });
        }
      });
      // 按 customerType 排序
      return data.sort(function (a, b) {
        return a.customerType - b.customerType;
      });
    },
    // 查看订舱明细
    bookingHeadWebInitProps: function bookingHeadWebInitProps() {
      var _this7 = this;
      var sequence = ['1', '2', '7', '8', '10', '9', '15', '16', '3', '5', '6', '99', '11', '12', '13', '14'];
      this.loading = (0, _utils.load)();
      (0, _booking.bookingHeadWebInitProps)(this.bookingId).then(function (res) {
        if (res.success) {
          _this7.bookingHeadwebVer = JSON.parse(JSON.stringify(res.data)); //没有实际用处后端要求
          res.data.webBkCustomerComs = _this7.handleInfoShou(res.data.webBkCustomerComs);
          res.data.webBkCustomerComs.forEach(function (item) {
            item.webBkCusCatalogComs = _this7.generateAndSortArray(item.webBkCusCatalogComs, sequence);
          });
          _this7.form = res.data;
          // 预配锁
          if (_this7.form.preLock === '1' || _this7.form.preLock === 1) {
            _this7.preLockFlag = true;
          } else {
            _this7.preLockFlag = null;
          }
          if (!(0, _validate.validateNull)(_this7.form.webBkChargeDetailComs)) {
            _this7.navTabList.push({
              name: '运价信息',
              nameEn: 'Freight rate'
            });
          }
          if (_this7.form.pol.startsWith('KR')) {
            _this7.$set(_this7.rules, 'expCustomsCntrType', [{
              required: true,
              message: _this7.$t('home.placehold'),
              trigger: 'change'
            }]);
            _this7.$set(_this7.rules, 'expCustomsCargoType', [{
              required: true,
              message: _this7.$t('home.placehold'),
              trigger: 'change'
            }]);
          }
          _this7.$set(_this7.form, 'porName', _this7.form.webBkExtendComs[0].porName);
          _this7.$set(_this7.form, 'polName', _this7.form.webBkExtendComs[0].polName);
          _this7.$set(_this7.form, 'podName', _this7.form.webBkExtendComs[0].podName);
          _this7.$set(_this7.form, 'delName', _this7.form.webBkExtendComs[0].delName);
          _this7.vessNameVoy = _this7.form.vesselCode + '.' + _this7.form.voyageNo + ' ' + _this7.form.voyageLeg;

          // 处理订舱人表结构的问题
          _this7.$set(_this7.form, 'bookingFwdPerson', res.data.webBkExtendComs[0].bookingFwdPerson);
          _this7.$set(_this7.form, 'bookingFwdTel', res.data.webBkExtendComs[0].bookingFwdTel);
          _this7.$set(_this7.form, 'bookingFwdEmail', res.data.webBkExtendComs[0].bookingFwdEmail);

          // 处理冷箱和危险品表结构的问题
          // this.form.webBkImoComs = res.data.webBkCargoComs[0].webBkImoComs || []
          // this.form.webBkReeferComs = res.data.webBkCargoComs[0].webBkReeferComs || []
          _this7.$set(_this7.form, 'webBkImoComs', res.data.webBkCargoComs[0].webBkImoComs);
          _this7.$set(_this7.form, 'webBkReeferComs', res.data.webBkCargoComs[0].webBkReeferComs);
          //  定义临时存储删除的数据的变量
          _this7.handleSetDelteList();
          //  获取业务员
          var dataPeople = {
            accountNo: _this7.userInfo.accountNo,
            pordCode: _this7.form.pol
          };
          (0, _booking.getSaleByAccountNo)(dataPeople).then(function (res) {
            _this7.form.sales = _this7.form.sales ? _this7.form.sales : res.data;
            // this.oldData = JSON.parse(JSON.stringify(this.form))//用来对于是否被更改
            // this.newData = this.form//用来对于是否被更改
          });
          //分单获取主单的信息
          if (_this7.form.bookingType2 === 0 && _this7.form.blType === 0) {
            (0, _booking.loadTopBlInfo)(_this7.bookingId).then(function (res) {
              if (res.success) {
                _this7.topBlInfo = res.data;
              }
            });
          }
          setTimeout(function () {
            var _this7$form$webBkCont;
            //把子组件延迟加箱信息的逻辑放在父页面，更方便判断是否修改数据提醒保存
            if (((_this7$form$webBkCont = _this7.form.webBkContainerComs) === null || _this7$form$webBkCont === void 0 ? void 0 : _this7$form$webBkCont.length) === 0) {
              var _this7$form;
              if (_this7.form.pol.startsWith('TH') || _this7.form.pol.startsWith('TW')) {
                return;
              }
              var data = {
                containerNo: '',
                containerType: '',
                containerStatus: 8,
                sealNo1: '',
                quantity: 0,
                weight: 0,
                cntrSize: 0,
                cargoTypeCode: '',
                overLeft: null,
                overRight: null,
                overHeight: null,
                overForeward: null,
                overAftward: null,
                socReturn: '',
                containerManager: _this7.form.socCheckFlag === 1 ? 'SOC' : 'SIT'
              };
              if (((_this7$form = _this7.form) === null || _this7$form === void 0 ? void 0 : _this7$form.webBkContainerComs.length) === 0) {
                data.quantity = _this7.form.cargoQuantity;
                data.weight = _this7.form.cargoGrossWeight;
                data.cntrSize = _this7.form.cargoSize;
              }
              _this7.form.webBkContainerComs.push(data);
            }
            _this7.oldData = JSON.parse(JSON.stringify(_this7.form)); //用来对于是否被更改
            _this7.newData = _this7.form; //用来对于是否被更改
            if (_this7.clickButton) {
              _this7.ishandleDelTag();
              _this7.clickButton = false;
            }
          }, 10);
          //  if(this.clickButton){
          //     this.ishandleDelTag()
          //     this.clickButton = false
          // }
        }
      }).finally(function () {
        _this7.loading.close();
        _this7.showCargoInfo = true;
        _this7.loadingTrue = true;
      });
    },
    handleSetDelteList: function handleSetDelteList() {
      this.form.deleteWebFeeItemComs = []; //附加费和杂费
      this.form.deleteWebBkDocumentComs = []; // BK document
      this.form.deleteWebBkContainerComs = []; // 箱信息
      this.form.deleteWebBkPreContainerComs = []; // 下货箱信息
      this.form.deleteWebBkRoutingComs = []; // 中转
      this.form.deleteWebBkImoComs = []; // imo
      this.form.deleteWebBkReeferComs = []; // 冷箱
      this.form.deleteWebBkAkComs = []; // 特种箱
      this.form.deleteWebBkSocComs = []; // soc
      this.form.deleteWebBkHgComs = []; // 特种箱
    },
    selectionChange: function selectionChange(row) {
      this.sailScheduleDialogVisible = false;
      var data = this.form.webBkRoutingComs[this.currentIndex];
      data.vesselCode = row.vesselCode;
      data.vesselName = row.vesselName;
      data.voyageNo = row.voyageNo;
      data.voyageLeg = row.voyageLeg;
      data.serviceLineCode = row.serviceLineCode;
    },
    handAddVesselInfo: function handAddVesselInfo(index) {
      this.currentIndex = index;
      this.sailScheduleDialogVisible = true;
    },
    // 获取包装类型
    queryListPackageType: function queryListPackageType() {
      var _this8 = this;
      var data = {
        pageSize: 1000,
        currentPage: 1
      };
      (0, _booking.queryListPackageType)(data).then(function (res) {
        _this8.packageTypeList = res.data.records || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "SERVICE_MODE"
      })).then(function (res) {
        _this8.transportationTermsList = res.data || [];
      });
      (0, _booking.queryListCodeName)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "CARGO_TYPE"
      })).then(function (res) {
        _this8.cargoList = res.data || [];
      });
      (0, _booking.queryListCode)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        type: "EQUIPMENT"
      })).then(function (res) {
        _this8.containerTypeList = res.data || [];
      });
    },
    selectTab: function selectTab(index) {
      this.selectedIndex = index;
      this.scrollToTarget(index);
    },
    scrollToTarget: function scrollToTarget(index) {
      var datamap = {
        0: 'basicInfo',
        1: 'consignerInfo',
        2: 'cargoInfo',
        3: 'boxInfo',
        4: 'otherInfo',
        5: 'chargeInfo'
      };
      var offsetTop = document.getElementById(datamap[index]).offsetTop;
      this.$refs.scrollMain.scrollTop = offsetTop - 50;
    },
    handleInit: function handleInit() {
      var _this9 = this;
      this.vessNameVoy = this.bookInfo.vesselName + this.bookInfo.voyageNo;
      this.form.saillingDate = this.bookInfo.polEtdStr;
      this.form.etd = this.bookInfo.polEtdStr && (0, _utils.parseTime)(this.bookInfo.polEtdStr, '{y}-{m}-{d} {h}:{i}:{s}');
      this.form.eta = this.bookInfo.podEtaStr;
      this.form.por = this.bookInfo.polHidden;
      this.form.pol = this.bookInfo.polHidden;
      this.form.del = this.bookInfo.podHidden;
      this.form.pod = this.bookInfo.podHidden;
      this.form.polName = this.bookInfo.pol;
      this.form.delName = this.bookInfo.pod;
      this.form.podName = this.bookInfo.pod;
      this.form.porName = this.bookInfo.pol;
      this.form.vesselCode = this.bookInfo.vesselCode;
      this.form.vesselName = this.bookInfo.vesselName;
      this.form.voyageLeg = this.bookInfo.voyageLeg;
      this.form.serviceLineCode = this.bookInfo.serviceLineCode;
      this.form.voyageNo = this.bookInfo.voyageNo;
      this.form.paidPalce = this.bookInfo.polHidden;
      console.log(this.userInfo, 'this.userInfo');
      //  this.form.bookingFwdPerson = this.userInfo.accountNo //当前用户code
      //  this.form.bookingFwdEmail = this.userInfo.activateEmail //当前用户电话
      if (this.bookInfo.isTs === '0') {
        var data = {
          tripNumber: 1,
          lineType: this.bookInfo.lineType,
          serviceLineCode: this.bookInfo.serviceLineCode,
          vesselCode: this.bookInfo.vesselCode,
          vesselName: this.bookInfo.vesselName,
          voyageNo: this.bookInfo.voyageNo,
          voyageLeg: this.bookInfo.voyageLeg,
          portFrom: this.bookInfo.polHidden,
          portTo: this.bookInfo.podHidden,
          etd: this.bookInfo.polEtdStr && (0, _utils.parseTime)(this.bookInfo.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
          eta: this.bookInfo.eta
        };
        console.log('this.form.webBkRoutingComs', data);
        this.form.webBkRoutingComs.push(data);
      }
      if (this.bookInfo.isTs === '1') {
        this.form.tsFlag = 1;
        this.form.webBkRoutingComs = this.bookInfo.routeList.map(function (item, index) {
          return {
            tripNumber: index + 1,
            lineType: item.lineType,
            serviceLineCode: item.serviceLineCode,
            vesselCode: item.vesselCode,
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            portFrom: item.polHidden,
            portTo: item.podHidden,
            etd: _this9.bookInfo.polEtdStr && (0, _utils.parseTime)(item.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
            eta: item.eta
          };
        });
      }
    },
    handleSelect: function handleSelect() {
      // this.$emit('handleSelect',this.form)
      this.submitForm();
    },
    showMessage: function showMessage(message) {
      this.$message({
        message: message,
        type: 'warning'
      });
    },
    handleValid: function handleValid() {
      var _this$form$webBkConta;
      var needContent = true;
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.form.webBkCustomerComs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ele = _step.value;
          var _iterator4 = (0, _createForOfIteratorHelper2.default)(ele.webBkCusCatalogComs),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _item = _step4.value;
              if (ele.customerType === 2 && _item.sequence === '1' && _item.catalogContent === 'SAME AS CONSIGNEE') {
                needContent = false;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(this.form.webBkCustomerComs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ele = _step2.value;
          var _iterator5 = (0, _createForOfIteratorHelper2.default)(_ele.webBkCusCatalogComs),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _item2 = _step5.value;
              if (_ele.customerType === 0 && _item2.sequence === '1' && !_item2.catalogContent) {
                console.log('catalogContent888', _ele.customerType, _item2.sequence, _item2.catalogContent);
                this.showMessage(this.$t('home.customerTypeOne'));
                return false;
              }
              // if (ele.customerType === 0 && item.sequence === '8' && !item.catalogContent) {
              //     this.showMessage(this.$t('home.customerTypeOne'));
              //     return false;
              // }
              if (_ele.customerType === 1 && _item2.sequence === '1' && !_item2.catalogContent) {
                this.showMessage(this.$t('home.customerTypeTwo'));
                return false;
              }
              if (_ele.customerType === 2 && _item2.sequence === '1' && !_item2.catalogContent) {
                console.log('catalogContent8899998', _ele.customerType, _item2.sequence, _item2.catalogContent);
                this.showMessage(this.$t('home.customerTypeThree'));
                return false;
              }
              if (_ele.customerType === 1 && this.form.pod && this.form.pod.startsWith('CN')) {
                if (_item2.sequence === '8' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeCN1'));
                  return false;
                }
                if (_item2.sequence === '9' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeCN3'));
                  return false;
                }
                if (_item2.sequence === '15' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeCN2'));
                  return false;
                }
              }
              //通知人1：当通知人名称不是SAME AS CONSIGNEE的时候，才要求必填
              if (_ele.customerType === 2) {
                if (this.form.pod && this.form.pod.startsWith('CN') || this.form.pol && this.form.pol.startsWith('TH')) {
                  if (needContent && _item2.sequence === '8' && !_item2.catalogContent) {
                    this.showMessage(this.$t('home.customerTypeCN11'));
                    return false;
                  }
                  if (needContent && _item2.sequence === '9' && !_item2.catalogContent) {
                    this.showMessage(this.$t('home.customerTypeCN13'));
                    return false;
                  }
                }
                if (this.form.pod && this.form.pod.startsWith('CN') && this.form.pol && !this.form.pol.startsWith('TH')) {
                  if (needContent && _item2.sequence === '15' && !_item2.catalogContent) {
                    this.showMessage(this.$t('home.customerTypeCN12'));
                    return false;
                  }
                }
              }
              if ((_ele.customerType === 0 || _ele.customerType === 1) && this.form.pol && this.form.pol.startsWith('TH')) {
                if (_item2.sequence === '7' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeTH1'));
                  return false;
                }
                if (_item2.sequence === '8' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeTH2'));
                  return false;
                }
                if (_item2.sequence === '15' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeTH3'));
                  return false;
                }
                if (_ele.customerType === 1 && _item2.sequence === '11' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeTH4'));
                  return false;
                }
                if (_ele.customerType === 1 && _item2.sequence === '13' && !_item2.catalogContent) {
                  this.showMessage(this.$t('home.customerTypeTH5'));
                  return false;
                }
              }
              // if (ele.customerType === 3 && item.sequence === '1' && !item.catalogContent) {
              //     this.showMessage(this.$t('home.customerTypeFour'));
              //     return false;
              // }
              if (this.form.pod == 'CNYNT' || this.form.pod == 'CNTXG') {
                console.log('catalogContent', _ele.customerType, _item2.sequence, _item2.catalogContent);
                if (_item2.sequence === '7' && !_item2.catalogContent && (_ele.customerType === 0 || _ele.customerType === 1 || _ele.customerType === 2)) {
                  console.log('c111atalogContent', _item2.sequence, _item2.catalogContent);
                  this.showMessage(this.$t('home.customerTypeFive'));
                  return false;
                }
                if (_item2.sequence === '8' && !_item2.catalogContent && (_ele.customerType === 0 || _ele.customerType === 1 || _ele.customerType === 2)) {
                  this.showMessage(this.$t('home.customerTypeSix'));
                  return false;
                }
              }
              if (this.form.pod == 'CNYNT') {
                if (_item2.sequence === '15' && !_item2.catalogContent && (_ele.customerType === 0 || _ele.customerType === 1)) {
                  this.showMessage(this.$t('home.customerTypeSeven'));
                  return false;
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        // if(this.form.pol.startsWith('KR')){
        //     if(!this.form.hsCode){
        //         this.showMessage(this.$t('home.hsCodeOne'))
        //         return false
        //     }
        //     if(!this.form.hsCodeCn){
        //         this.showMessage(this.$t('home.hsCodeTwo'))
        //         return false
        //     }
        //     if(!this.form.hsCodeJp){
        //         this.showMessage(this.$t('home.hsCodeThree'))
        //         return false
        //     }
        // }
        // 下货箱信息箱型为HR/RF时,校验冷箱
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (this.form.webBkPreContainerComs.length > 0) {
        // const found = this.form.webBkPreContainerComs.some(item => item.containerType.includes('HR') || item.containerType.includes('RF'));
        // if (found && this.form.webBkReeferComs.length === 0) {
        //     this.$message({
        //             message: this.$t('home.toastOne'),
        //             type: 'warning'
        //         });
        //    return false
        // }
        var foundOne = this.form.webBkPreContainerComs.some(function (item) {
          return item.containerType.includes('FR') || item.containerType.includes('OT');
        });
        if (foundOne && this.form.webBkAkComs.length === 0) {
          if (!this.form.akCheckFlag) {
            this.$message({
              message: this.$t('home.toastTwo'),
              type: 'warning'
            });
            console.log('foundOne3333', foundOne);
            return false;
          }
        }
        var foundTwo = this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0003' || item.cargoTypeCode === '0004' || item.cargoTypeCode === '0022';
        });
        if (foundTwo && this.form.webBkImoComs.length === 0) {
          this.$message({
            message: this.$t('home.toastThree'),
            type: 'warning'
          });
          return false;
        }
        var foundThree = this.form.webBkPreContainerComs.some(function (item) {
          return item.cargoTypeCode === '0002';
        });
        if (foundThree && this.form.webBkReeferComs.length === 0) {
          this.$message({
            message: this.$t('home.toastFour'),
            type: 'warning'
          });
          return false;
        }
        var _iterator3 = (0, _createForOfIteratorHelper2.default)(this.form.webBkPreContainerComs),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            if (item.cargoTypeCode === '0002') {
              if (!(item.containerType.includes('HR') || item.containerType.includes('RF'))) {
                this.$message({
                  message: this.$t('home.toastFive'),
                  type: 'warning'
                });
                return false;
              }
            }
          }
          // const foundFour = this.form.webBkPreContainerComs.some(item => item.cargoTypeCode==='0003' );
          // const foundSix = this.form.webBkPreContainerComs.some(item => item.containerType.includes('HR') || item.containerType.includes('RF'));
          // if (foundFour && foundSix) {
          //     this.$message({
          //             message: this.$t('home.toastFive'),
          //             type: 'warning'
          //         })
          //     return false
          // }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      // 货物信息和箱信息件重尺校验
      if (((_this$form$webBkConta = this.form.webBkContainerComs) === null || _this$form$webBkConta === void 0 ? void 0 : _this$form$webBkConta.length) !== 0) {
        var quantity = Number(this.$refs.boxInfo.quantityCount);
        var weight = Number(this.$refs.boxInfo.weightCount);
        var Size = Number(this.$refs.boxInfo.cntrSizeCount);
        if (this.form.cargoQuantity !== quantity || this.form.cargoGrossWeight !== weight || this.form.cargoSize !== Size) {
          this.$message({
            message: this.$t('home.toastNine'),
            type: 'warning'
          });
          return false;
        }
      }
      //  if(this.bookInfo && this.bookInfo.slotControlStatus == "1"){
      //      if(this.form.webBkPreContainerComs.length>1){
      //          this.$message({
      //              message: this.$t('home.toastSeven'),
      //              type: 'warning'
      //          })
      //          return false
      //      }
      //      if(this.form.webBkPreContainerComs[0].quantity!==1){
      //          this.$message({
      //              message: this.$t('home.toastEight'),
      //              type: 'warning'
      //          })
      //          return false
      //      }

      //  }
      if (this.form.pod === 'CNSHA') {
        var _this$form, _this$form$webBkCusto, _this$form2, _this$form2$webBkCust, _consignerInfoOne$web;
        var _consignerReceiveInfo = ((_this$form = this.form) === null || _this$form === void 0 ? void 0 : (_this$form$webBkCusto = _this$form.webBkCustomerComs) === null || _this$form$webBkCusto === void 0 ? void 0 : _this$form$webBkCusto[1]) || [];
        var _consignerInfoOne = ((_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : (_this$form2$webBkCust = _this$form2.webBkCustomerComs) === null || _this$form2$webBkCust === void 0 ? void 0 : _this$form2$webBkCust[2]) || [];
        var consignerReceiveInfoFlag = false;
        var consignerInfoOneFlag = false;
        if (!(_consignerReceiveInfo.webBkCusCatalogComs[6].catalogContent + '').startsWith('USCI+')) {
          consignerReceiveInfoFlag = true;
        }
        if (!(_consignerInfoOne.webBkCusCatalogComs[6].catalogContent + '').startsWith('USCI+') && ((_consignerInfoOne$web = _consignerInfoOne.webBkCusCatalogComs[0]) === null || _consignerInfoOne$web === void 0 ? void 0 : _consignerInfoOne$web.catalogContent) !== 'SAME AS CONSIGNEE') {
          consignerInfoOneFlag = true;
        }
        // 根据三种情况给出不同的提示
        if (consignerReceiveInfoFlag && !consignerInfoOneFlag) {
          this.$message({
            message: this.$t('home.startWithUSCI1'),
            type: 'warning'
          });
          return false;
        } else if (!consignerReceiveInfoFlag && consignerInfoOneFlag) {
          this.$message({
            message: this.$t('home.startWithUSCI2'),
            type: 'warning'
          });
          return false;
        } else if (consignerReceiveInfoFlag && consignerInfoOneFlag) {
          this.$message({
            message: this.$t('home.startWithUSCI3'),
            type: 'warning'
          });
          return false;
        }
      }
      return true;
    },
    //  处理被删除的数据
    handSetData: function handSetData(form) {
      // 下货纸箱
      form.webBkPreContainerComs = [].concat((0, _toConsumableArray2.default)(form.webBkPreContainerComs), (0, _toConsumableArray2.default)(form.deleteWebBkPreContainerComs));
      delete form.deleteWebBkPreContainerComs;
      // 附加费杂费
      form.webFeeItemComs = [].concat((0, _toConsumableArray2.default)(form.webFeeItemComs), (0, _toConsumableArray2.default)(form.deleteWebFeeItemComs));
      delete form.deleteWebFeeItemComs;
      // BK document
      form.webBkDocumentComs = [].concat((0, _toConsumableArray2.default)(form.webBkDocumentComs), (0, _toConsumableArray2.default)(form.deleteWebBkDocumentComs));
      delete form.deleteWebBkDocumentComs;
      // 中转
      form.webBkRoutingComs = [].concat((0, _toConsumableArray2.default)(form.webBkRoutingComs), (0, _toConsumableArray2.default)(form.deleteWebBkRoutingComs));
      delete form.deleteWebBkRoutingComs;
      // 危险品
      form.webBkImoComs = [].concat((0, _toConsumableArray2.default)(form.webBkImoComs), (0, _toConsumableArray2.default)(form.deleteWebBkImoComs));
      delete form.deleteWebBkImoComs;
      // 冷箱
      form.webBkReeferComs = [].concat((0, _toConsumableArray2.default)(form.webBkReeferComs), (0, _toConsumableArray2.default)(form.deleteWebBkReeferComs));
      delete form.deleteWebBkReeferComs;
      // 特种箱
      form.webBkAkComs = [].concat((0, _toConsumableArray2.default)(form.webBkAkComs), (0, _toConsumableArray2.default)(form.deleteWebBkAkComs));
      delete form.deleteWebBkAkComs;
      // soc
      form.webBkSocComs = [].concat((0, _toConsumableArray2.default)(form.webBkSocComs), (0, _toConsumableArray2.default)(form.deleteWebBkSocComs));
      delete form.deleteWebBkSocComs;
      // 挂衣箱
      form.webBkHgComs = [].concat((0, _toConsumableArray2.default)(form.webBkHgComs), (0, _toConsumableArray2.default)(form.deleteWebBkHgComs));
      delete form.deleteWebBkHgComs;

      // 箱信息
      form.webBkContainerComs = [].concat((0, _toConsumableArray2.default)(form.webBkContainerComs), (0, _toConsumableArray2.default)(form.deleteWebBkContainerComs));
      delete form.deleteWebBkContainerComs;
      return form;
    },
    checkValidateContainerNo: function () {
      var _checkValidateContainerNo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this$form$webBkConta2;
        var form, data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(((_this$form$webBkConta2 = this.form.webBkContainerComs) === null || _this$form$webBkConta2 === void 0 ? void 0 : _this$form$webBkConta2.length) !== 0 && this.validateContainerNoFlag)) {
                _context.next = 20;
                break;
              }
              form = JSON.parse(JSON.stringify(this.form));
              data = this.handSetData(form);
              this.loading = (0, _utils.load)();
              _context.next = 6;
              return (0, _booking.validateContainerNo)(data);
            case 6:
              res = _context.sent;
              if (!res.success) {
                _context.next = 18;
                break;
              }
              if (!res.data) {
                _context.next = 16;
                break;
              }
              this.validateContainerNoMsg = res.data;
              this.validateContainerNoVisible = true;
              this.validateContainerNoFlag = true;
              this.loading.close();
              return _context.abrupt("return", true);
            case 16:
              this.loading.close();
              return _context.abrupt("return", false);
            case 18:
              _context.next = 22;
              break;
            case 20:
              this.loading.close();
              return _context.abrupt("return", false);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkValidateContainerNo() {
        return _checkValidateContainerNo.apply(this, arguments);
      }
      return checkValidateContainerNo;
    }(),
    checkValidateKRXXXBKDocument: function checkValidateKRXXXBKDocument() {
      if (this.form.pol.startsWith('KR')) {
        if (this.form.expCustomsCntrType === 1 || this.form.expCustomsCntrType === 2) {
          return false;
        } else {
          var propsToCheck = ['documentNo', 'packageCount', 'packageType', 'weight', 'isSplit', 'useTimes']; // 只检查这些属性
          if (this.form.webBkDocumentComs.length === 0) {
            return true;
          } else {
            return this.form.webBkDocumentComs.some(function (obj) {
              return propsToCheck.every(function (prop) {
                var value = obj[prop];
                return value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0 || (0, _typeof2.default)(value) === 'object' && value !== null && Object.keys(value).length === 0;
              });
            });
          }
        }
      } else {
        return false;
      }
    },
    // 保存
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(row) {
        var _this10 = this;
        var bkVgmContainers, checkCargoDesc, checkValidateFeeInfoFlag, form, newForm;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loading = (0, _utils.load)();
              this.saveIndex = row;
              if (this.form.bookingHeadWebComId) {
                // 处理冷箱和危险品具体后端要求的结构形式
                this.form.webBkCargoComs[0].webBkImoComs = this.form.webBkImoComs;
                this.form.webBkCargoComs[0].webBkReeferComs = this.form.webBkReeferComs;
              }
              this.form.webBkExtendComs[0].bookingFwdPerson = this.form.bookingFwdPerson;
              this.form.webBkExtendComs[0].bookingFwdTel = this.form.bookingFwdTel;
              this.form.webBkExtendComs[0].bookingFwdEmail = this.form.bookingFwdEmail;
              //  处理VGM的信息
              bkVgmContainers = this.$refs.boxInfo.getVgmContainers(); //去掉hsCode的同步
              // if(!this.form.hsCode){
              //    this.form.hsCode = this.form.hsCodeCn || this.form.hsCodeJp
              // }
              // if(!this.form.hsCodeCn){
              //    this.form.hsCodeCn = this.form.hsCode || this.form.hsCodeJp
              // }
              // if(!this.form.hsCodeJp){
              //    this.form.hsCodeJp = this.form.hsCode || this.form.hsCodeCn
              // }
              _context3.next = 9;
              return this.$store.dispatch("isSaveTip/checkValidateCargoDesc", this.form);
            case 9:
              checkCargoDesc = _context3.sent;
              if (checkCargoDesc) {
                _context3.next = 13;
                break;
              }
              this.loading.close();
              return _context3.abrupt("return");
            case 13:
              _context3.next = 15;
              return this.$store.dispatch("isSaveTip/checkValidateFeeInfo", this.form);
            case 15:
              checkValidateFeeInfoFlag = _context3.sent;
              if (!checkValidateFeeInfoFlag) {
                _context3.next = 19;
                break;
              }
              this.loading.close();
              return _context3.abrupt("return");
            case 19:
              if (!this.validCustomerInfoFlag) {
                _context3.next = 24;
                break;
              }
              this.validCustomer();
              this.loading.close();
              if (!this.validCustomerInfoVisible) {
                _context3.next = 24;
                break;
              }
              return _context3.abrupt("return");
            case 24:
              form = JSON.parse(JSON.stringify(this.form));
              newForm = this.handSetData(form);
              newForm.status = row;
              this.$refs.form.validate( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
                  var checkValidateContainerNoFlag, data;
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 18;
                          break;
                        }
                        if (!_this10.handleValid()) {
                          _context2.next = 15;
                          break;
                        }
                        _context2.next = 4;
                        return _this10.checkValidateContainerNo();
                      case 4:
                        checkValidateContainerNoFlag = _context2.sent;
                        if (!checkValidateContainerNoFlag) {
                          _context2.next = 8;
                          break;
                        }
                        _this10.loading.close();
                        return _context2.abrupt("return");
                      case 8:
                        if (!_this10.checkValidateKRXXXBKDocument()) {
                          _context2.next = 11;
                          break;
                        }
                        _this10.loading.close();
                        return _context2.abrupt("return", _this10.$message.warning(_this10.$t('home.validateKRXXXBKDocument')));
                      case 11:
                        data = {
                          bookingHeadWeb: newForm,
                          bkVgmContainers: bkVgmContainers || [],
                          bookingHeadwebVer: _this10.bookingHeadwebVer
                        };
                        (0, _booking.saveOrUpdateAmendBkWebCom2)(data).then(function (res) {
                          console.log(res);
                          _this10.$store.dispatch("isSaveTip/isToastSave", false);
                          if (res.success) {
                            // this.$message({
                            //     message: this.$t('home.saveSuccess'),
                            //     type: 'success'
                            // });
                            _this10.$confirm(_this10.$t('home.saveSuccess') + '【' + res.data.bkNo + '】', _this10.$t('confirmMsg.title'), {
                              confirmButtonText: _this10.$t('confirmMsg.close'),
                              cancelButtonText: _this10.$t('confirmMsg.close'),
                              showCancelButton: false,
                              showClose: false,
                              closeOnClickModal: false,
                              type: 'success'
                            }).then(function () {
                              //如果旧数据跟新数据不一样的话，关闭页面会触发保存提示弹窗
                              _this10.oldData = _this10.newData;
                              var data = {
                                view: _this10.$route
                              };
                              //关闭当前路由
                              _this10.$store.dispatch('tagsView/detailTabDelete', data);
                              _this10.$router.push({
                                path: '/bookingSpace/bookingSpaceMy'
                              });
                            });
                          }
                        }).catch(function (err) {
                          _this10.clickButton = false;
                        }).finally(function () {
                          _this10.loading.close();
                        });
                        _context2.next = 16;
                        break;
                      case 15:
                        _this10.loading.close();
                      case 16:
                        _context2.next = 20;
                        break;
                      case 18:
                        _this10.loading.close();
                        _this10.$nextTick(function () {
                          var errorField = document.querySelector(".is-error");
                          if (errorField) {
                            // 滚动到第一个校验错误的元素
                            errorField.scrollIntoView({
                              behavior: "smooth",
                              block: "center"
                            });
                          }
                        });
                      case 20:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleSave(_x) {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    handleCopy: function handleCopy() {
      this.copyId = this.form.bookingHeadWebComId;
      this.copyVisible = true;
    },
    handleSaveDraft: function handleSaveDraft() {
      this.handleSave(14);
    },
    submitForm: function submitForm() {
      this.$refs.form.validate(function (valid) {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    getValidCustomerInfoList: function () {
      var _getValidCustomerInfoList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _booking.queryBkCustomerRf)();
            case 2:
              res = _context4.sent;
              if (res.success) {
                if (res.data) {
                  this.allValidCustomerInfo = res.data;
                }
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getValidCustomerInfoList() {
        return _getValidCustomerInfoList.apply(this, arguments);
      }
      return getValidCustomerInfoList;
    }(),
    validCustomerInfoList: function validCustomerInfoList() {
      var _this11 = this;
      var portResList = [];
      if (this.allValidCustomerInfo) {
        //拿到所有规则数据
        var list = this.allValidCustomerInfo;
        //测POR:form.por 接货地
        var porArr = list.filter(function (item) {
          return item.portType === '00' && item.portCode === _this11.form.por;
        });
        //测POL:form.pol 装货港
        var polArr = list.filter(function (item) {
          return item.portType === '01' && item.portCode === _this11.form.pol;
        });
        //测POD:form.pod 卸货港
        var podArr = list.filter(function (item) {
          return item.portType === '10' && item.portCode === _this11.form.pod;
        });
        //测DEL:form.del 目的地
        var delArr = list.filter(function (item) {
          return item.portType === '11' && item.portCode === _this11.form.del;
        });

        //测portFrom、portTo，程次起运港，程次抵达港
        var webBkRoutingComs = this.form.webBkRoutingComs;
        var portFrom = [];
        var portTo = [];
        webBkRoutingComs.forEach(function (it, index, array) {
          var from = list.filter(function (item) {
            return item.portType === '02' && item.portCode === it.portFrom;
          });
          var to = list.filter(function (item) {
            return item.portType === '12' && item.portCode === it.portTo;
          });
          portFrom = [].concat((0, _toConsumableArray2.default)(portFrom), (0, _toConsumableArray2.default)(from));
          portTo = [].concat((0, _toConsumableArray2.default)(portTo), (0, _toConsumableArray2.default)(to));
        });
        portResList = [].concat((0, _toConsumableArray2.default)(porArr), (0, _toConsumableArray2.default)(polArr), (0, _toConsumableArray2.default)(podArr), (0, _toConsumableArray2.default)(delArr), (0, _toConsumableArray2.default)(portFrom), (0, _toConsumableArray2.default)(portTo));
        return portResList;
      }
    },
    validCustomer: function validCustomer() {
      var _this12 = this;
      //拿到所有符合港口代码的数据
      var list = this.validCustomerInfoList();
      if (!list) {
        return;
      }
      var webBkCustomerComs = this.form.webBkCustomerComs;
      var resList = [];
      this.validCustomerTips = [];
      webBkCustomerComs.forEach(function (webBkCustomerComsItem, index, array) {
        if (index === 1 && ((webBkCustomerComsItem.webBkCusCatalogComs[0].catalogContent + '').startsWith('TO ORDER') || (webBkCustomerComsItem.webBkCusCatalogComs[0].catalogContent + '').startsWith('TO THE ORDER'))) {
          return;
        }
        if (index === 2 && webBkCustomerComsItem.webBkCusCatalogComs[0].catalogContent + '' == 'SAME AS CONSIGNEE') {
          return;
        }
        var conList = list.filter(function (item) {
          return item.customerType == index + '';
        });
        if (conList && webBkCustomerComsItem) {
          conList.forEach(function (consignorItem, index, array) {
            var con = _this12.requiredFieldContent(consignorItem, webBkCustomerComsItem);
            if (con) {
              resList.push(con);
            }
          });
        }
      });
      if (resList) {
        var mySort = function mySort(a, b) {
          if (a.portCode !== b.portCode) return a.portCode < b.portCode ? -1 : 1;else if (a.portType !== b.portType) return a.portType < b.portType ? -1 : 1;else if (a.customerType !== b.customerType) return a.customerType < b.customerType ? -1 : 1;
        }; //提示
        // 只是展示之前的调整
        var control00 = resList.filter(function (item) {
          return item.controlMode == '00';
        });
        var control01 = resList.filter(function (item) {
          return item.controlMode == '01';
        });
        if (control00) {
          control00.sort(mySort);
          var tip = '';
          control00.forEach(function (item, index, array) {
            var port = _this12.$t('home.customerInfoPort') + item.portCode + '， ';
            var portType = _this12.$t('home.customerInfoPortType') + _this12.getFieldName('portType', item.portType) + '， ';
            var customerType = _this12.$t('home.customerInfoCustomerType') + _this12.getFieldName('customerType', item.customerType) + '， ';
            var requiredField = _this12.$t('home.customerInfoRequiredField') + _this12.getFieldName('requiredField', item.requiredField) + '， ';
            var shouldInclude = item.content ? _this12.$t('home.customerInfoShouldInclude') + item.content : _this12.$t('home.canNotNull');
            tip = tip + port + portType + customerType + requiredField + shouldInclude + '\n';
          });
          this.validCustomerTips[0] = tip;
        }
        //强制
        if (control01) {
          control01.sort(mySort);
          var _tip = '';
          control01.forEach(function (item, index, array) {
            var port = _this12.$t('home.customerInfoPort') + item.portCode + '， ';
            var portType = _this12.$t('home.customerInfoPortType') + _this12.getFieldName('portType', item.portType) + '， ';
            var customerType = _this12.$t('home.customerInfoCustomerType') + _this12.getFieldName('customerType', item.customerType) + '， ';
            var requiredField = _this12.$t('home.customerInfoRequiredField') + _this12.getFieldName('requiredField', item.requiredField) + '， ';
            var shouldInclude = item.content ? _this12.$t('home.customerInfoShouldInclude') + item.content : _this12.$t('home.canNotNull');
            _tip = _tip + port + portType + customerType + requiredField + shouldInclude + '\n';
          });
          this.validCustomerTips[1] = _tip;
        }
        //弹窗
        if (this.validCustomerTips[0] || this.validCustomerTips[1]) {
          this.validCustomerInfoVisible = true;
          this.validCustomerInfoFlag = true;
        }
      }
    },
    // 判断规则，用于遍历，拿到最后的显示字段，不区分必填和提示
    requiredFieldContent: function requiredFieldContent(item, customer) {
      var mapping = {
        '2': 1,
        //地址
        '3': 8,
        //城市名称
        '5': 9,
        //省份名称
        '6': 10,
        //邮政编码
        '8': 3,
        //电话
        '9': 5 //邮件地址，邮箱
      };
      if (!item.content && !customer.webBkCusCatalogComs[mapping[item.requiredField]].catalogContent) {
        return item;
      } else if (item.content && !(customer.webBkCusCatalogComs[mapping[item.requiredField]].catalogContent + '').includes(item.content + '')) {
        return item;
      }
    },
    getFieldName: function getFieldName(field, value) {
      var fields = {
        //港口类型
        'portType': {
          '00': this.$t('home.por'),
          '01': this.$t('home.pol'),
          '02': this.$t('home.customerInfoPortFrom'),
          '10': this.$t('home.pod'),
          '11': this.$t('home.del'),
          '12': this.$t('home.customerInfoPortTo')
        },
        //收发通类型
        'customerType': {
          '0': this.$t('home.consignerInfo'),
          '1': this.$t('home.consignerReceiveInfo'),
          '2': this.$t('home.notifierInfo'),
          '3': this.$t('home.notifierInfoTwo')
        },
        //字段名称
        'requiredField': {
          '2': this.$t('home.address'),
          '3': this.$t('home.notifierCity'),
          '5': this.$t('home.notifierProvince'),
          '6': this.$t('home.notifierPostalCode'),
          '8': this.$t('home.consignerPhone'),
          '9': this.$t('home.consignerEmail')
        }
      };
      var displayFields = fields[field + ''];
      if (displayFields) {
        return displayFields[value + ''];
      }
    }
  }
};